import KNavList from "./KNavList";
import menu from "@/data/menus/front";
import { getRoutePermissions } from "kinnect-helpers";
import {
	VBtn,
	VCol,
	VContainer,
	VIcon,
	VImg,
	VNavigationDrawer,
	VRow,
	VSpacer
} from "vuetify/lib";

export default {
	name: "KNav",

	data: () => ( {
		navItemsData: JSON.parse( JSON.stringify( menu ) )
	} ),

	computed: {
		drawer: {
			get() {
				return this.$store.state.app.drawer;
			},

			set( val ) {
				return this.$store.dispatch( "app/setDrawer", val );
			}
		},

		isAuthenticated() {
			return this.$store.getters["auth/isAuthenticated"];
		},

		topNavItems() {
			if ( this.navItemsData.top ) {
				return this.filterNavItems( this.navItemsData.top );
			}
		},

		bottomNavItems() {
			if ( this.navItemsData.bottom ) {
				return this.filterNavItems( this.navItemsData.bottom );
			}
		},

		genNavTop() {
			if ( this.topNavItems ) {
				return <KNavList dense items={this.topNavItems}></KNavList>;
			}
		},

		genNavBottom() {
			if ( this.bottomNavItems ) {
				return [
					<VSpacer></VSpacer>,
					<KNavList dense items={this.bottomNavItems}></KNavList>
				];
			}
		}
	},

	methods: {
		filterNavItems( items ) {
			if ( Array.isArray( items ) ) {
				return JSON.parse( JSON.stringify( items ) )
				.filter( this.isNavItemVisible )
				.map( item => {
					if ( item.hasOwnProperty( "items" ) ) {
						item.items = this.filterNavItems( item.items );
					}

					return item;
				} );
			}

			return items;
		},

		isNavItemVisible( navItem ) {
			let isVisible = false;

			if ( navItem.items ) {

				// Visible if has children and any are visible
				isVisible = navItem.items.some( child => this.isNavItemVisible( child ) );
			} else if ( navItem.target ) {

				// Visible if external link
				isVisible = true;
			} else if ( navItem.href ) {

				// Visible if has permission to view route
				isVisible = this.$can( getRoutePermissions(
					this.$router.resolve( navItem.href ).route
				) );
			} else if ( navItem.hasOwnProperty( "divider" )
				&& Object.keys( navItem ).length === 1
			) {

				// Visible if just a divider
				isVisible = true;
			}

			return isVisible;
		}
	},

	render() {
		if ( !this.isAuthenticated || !this.navItemsData ) {
			return;
		}

		return <VNavigationDrawer
			app
			class="pb-2"
			fixed
			temporary
			touchless
			vModel={this.drawer}
			width={300}
		>
			<VCol class="d-flex flex-column fill-height pa-0">
				<VContainer>
					<VRow noGutters>
						<VImg
							alt="Kinnect"
							maxWidth={82}
							src={require( "@/assets/logos/logo-small.png" )}
						></VImg>

						<VSpacer></VSpacer>

						<VBtn icon onClick={() => this.drawer = false}>
							<VIcon>chevron_left</VIcon>
						</VBtn>
					</VRow>
				</VContainer>

				{this.genNavTop}
				{this.genNavBottom}
			</VCol>
		</VNavigationDrawer>;
	}
};
